import React from "react";
import { createRoot } from "react-dom/client";
import "@/index.css";
import App from "@/App";

// react-snap pre-renders full static HTML for every route at build time, which
// is what search engines and AI crawlers consume. On the client we mount with
// createRoot (not hydrate) to avoid React 19 / react-snap hydration mismatches
// from native document-metadata hoisting; the pre-rendered markup is replaced
// by a clean client render after a fast first paint.
const rootElement = document.getElementById("root");
createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
